import {
  Component,
  OnInit,
  Input,
  AfterContentInit,
  ViewChild,
  AfterViewInit,
  ViewEncapsulation,
  inject
} from '@angular/core';
import { TabDirective, TabsetComponent } from 'ngx-bootstrap/tabs/public_api';
import { Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';

import { NgxSpinnerService } from 'ngx-spinner';
import { Meta } from '@angular/platform-browser';
import {EnvironmentService} from '../../_services/environment.service';
import {SiteConfigService} from "../../_services/site-config.service";

@Component({
  selector: 'app-enotification',
  templateUrl: './enotification.component.html',
  styleUrls: ['./enotification.component.scss']
})
export class EnotificationComponent implements OnInit {

  siteConfigService = inject(SiteConfigService);

  constructor(private metaService: Meta,
              public envService: EnvironmentService) { }

  ngOnInit() {
    this.metaService.updateTag({ name: 'keywords', content: 'Los Angeles County Assessor’s Property Owner e-Notification Alert,Los angeles assessor, enotification, los angeles county' });

  }

  get buttonClass(): string {
    return this.siteConfigService.isGlobalMaintenanceEFI() ? 'btn btn-primary disabled-link' : 'btn btn-primary';
  }

  get buttonToolTip(): string {
    return this.siteConfigService.isGlobalMaintenanceEFI() ? 'Temporarily Disabled' : null;
  }

}
